import * as React from 'react';
import client from '../api/contentful';
import { Entry } from 'contentful';

interface IFooter {
  currentLocation: string;
  email: string;
  emailTitle: string;
  employmentStatus: string;
  facebook: string;
  instagram: string;
  phoneNumber: string;
  bluesky: string;
  linkedIn: string;
  cv: Entry<{
    title: string;
    file: {
      url: string;
    };
  }>;
}

export type FooterEntry = Entry<IFooter>;

export default class Footer {
  static data: FooterEntry;
  private static promise: Promise<FooterEntry>;

  static getData(): Promise<FooterEntry> {
    if (Footer.promise) {
      return Footer.promise;
    }

    const promise = client
      .getEntries<IFooter>({
        content_type: 'about',
      })
      .then((data) => {
        Footer.data = data.items[0];

        return data.items[0];
      });

    Footer.promise = promise;

    return promise;
  }
}

export interface IRenderProps {
  data: FooterEntry;
}

interface IProps {
  render:
    | ((props: IRenderProps) => React.ReactNode)
    | React.ComponentClass<IRenderProps>;
  fallback?: React.SFC | React.ComponentClass;
  [key: string]: any;
}

interface IState {
  data: FooterEntry | undefined;
}

function isComponentClass(render: any): render is React.ComponentClass {
  return undefined !== render.prototype.isReactComponent;
}

const blackList = new Set(['render', 'fallback']);

export class FooterRenderer extends React.PureComponent<IProps, IState> {
  state: IState = {
    data: undefined,
  };

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    Footer.getData().then((data) => this.setState({ data }));
  }

  render() {
    const extraProps = Object.keys(this.props).reduce((acc, key) => {
      if (!blackList.has(key)) {
        acc[key] = this.props[key];
      }
      return acc;
    }, {});

    if (this.state.data) {
      if (isComponentClass(this.props.render)) {
        const Render = this.props.render;
        return <Render data={this.state.data} {...extraProps} />;
      }

      return this.props.render({
        data: this.state.data,
        ...extraProps,
      });
    }

    if (this.props.fallback) {
      const Fallback = this.props.fallback;

      return <Fallback />;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/models/Footer.tsx